import { render, staticRenderFns } from "./settingModel.vue?vue&type=template&id=ff1ea1fe&scoped=true"
import script from "./settingModel.vue?vue&type=script&lang=js"
export * from "./settingModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1ea1fe",
  null
  
)

export default component.exports